import { FiContentLanguageLabelObjectType } from '../../core/content-language-label-object-type';

export class WidgetContentLanguageLabelModel {
    Id = 0;
    WidgetModuleContentId = 0;
    ContentLanguageId = 0;
    ContentLanguageLabelObjectType = FiContentLanguageLabelObjectType.WidgetModuleNames;
    Value = '';
    SortIndex: number;

    constructor(initializeItem?) {
        if (initializeItem) {
            this.Initialize(initializeItem);
        }
    }

    Initialize(item: WidgetContentLanguageLabelModel) {
        this.Id = item.Id;
        this.WidgetModuleContentId = item.WidgetModuleContentId;
        this.ContentLanguageId = item.ContentLanguageId;
        this.ContentLanguageLabelObjectType = item.ContentLanguageLabelObjectType;
        this.Value = item.Value;
    }

    InitializeFromLanguageItem(languageItem, widgetModuleContentId: number) {
        this.ContentLanguageId = languageItem.Id;
        this.WidgetModuleContentId = widgetModuleContentId;
        this.SortIndex = languageItem.SortIndex;
    }
}
